import axios from "axios";
import { SERVER_URL } from "../config";

export const fetchCustomerwiseReport = async (filters = {}) => {
  const payload = {
    from_date: filters.fromDate,
    to_date: filters.toDate,
    region: filters.region || "",
    party: filters.party || "",
  };

  const res = await axios.post(`${SERVER_URL}/db.php`, payload);
  return res.data;
};
